import { z } from 'zod';

const REQUIRED_MESSAGE = 'Please type something';

const RequiredString = z
  .string({ required_error: REQUIRED_MESSAGE })
  .min(1, { message: REQUIRED_MESSAGE });

export { RequiredString };
